import { DFVariableCharges } from './df-master-data.model';
import { TransactionData } from './df-transaction-data.model';
import { UploadFileMasterDataMandatoryColumn } from './upload-file-master-data--mandatory-column';
import { UploadFileMasterDataColumn } from './upload-file-master-data-column';
import { UploadFileMasterDataParseError } from './upload-file-master-data-parse-error';
import { UploadFileTransactionDataResultList } from './upload-file-transaction-data-resultList.model';


export class DFUploadTransactionData {

  public countOfErrorRecords: string;
  public countOfRecordsInCMA: string;
  public countOfRecordsInExcel: string;
  public failed: string;
  public failedRows: TransactionData[];
  public missingColumns: UploadFileMasterDataColumn[];
  public missingMandatoryColumnValues: UploadFileMasterDataMandatoryColumn[];
  public parseErrors: UploadFileMasterDataParseError[]
  public reason: string;
  public status: string;
  public succeed: boolean;
  public unexpectedColumns: { name: string, position: number }[];
  public failedImportReportByteStream: string;
  public resultList: UploadFileTransactionDataResultList[];


  static fromDto(data: any): DFUploadTransactionData {
    if (!data) {
      return null;
    }

    const importResult = new DFUploadTransactionData();

    let failedRows: TransactionData[] = [];
    let missingColumns: UploadFileMasterDataColumn[] = [];
    let missingMandatoryColumnValues: UploadFileMasterDataMandatoryColumn[] = [];
    let parseErrors: UploadFileMasterDataParseError[] = [];
    let resultList: UploadFileTransactionDataResultList[] = [];

    importResult.countOfErrorRecords = data.countOfErrorRecords;
    importResult.countOfRecordsInCMA = data.countOfRecordsInCMA;
    importResult.countOfRecordsInExcel = data.countOfRecordsInExcel;
    importResult.failed            = data.failed;
    importResult.status            = data.status;
    importResult.reason            = data.reason;
    importResult.succeed            = data.succeed ;
    importResult.unexpectedColumns = data.unexpected_columns || [];
    importResult.failedImportReportByteStream = data.failedImportReportByteStream;

    if (data.failedRows) {
      failedRows = data.failedRows.map(c => TransactionData.fromDto(c));
    }

    if (data.missingColumns) {
      missingColumns = data.missingColumns.map(c => UploadFileMasterDataColumn.fromDto(c));
    }

    if (data.missingMandatoryColumnValues) {
      missingMandatoryColumnValues = data.missingMandatoryColumnValues.map(c => UploadFileMasterDataMandatoryColumn.fromDto(c));
    }

    if (data.parseErrors) {
      parseErrors = data.parseErrors.map(e => UploadFileMasterDataParseError.fromDto(e));
    }

    if (data.resultList) {
      resultList = data.resultList.map(c => UploadFileTransactionDataResultList.fromDto(c));
    }

    importResult.failedRows = failedRows;
    importResult.missingColumns = missingColumns;
    importResult.missingMandatoryColumnValues = missingMandatoryColumnValues;
    importResult.parseErrors = parseErrors;
    importResult.resultList = resultList;

    return importResult;
  }
}
